import { CaretDown, FileText } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import type { Article } from "../types";
import { ArticleMedia } from "./ArticleMedia";

export function NewsRanking({
  articles,
  onOpen,
  title = "Najnowsze wiadomości",
}: {
  articles: Article[];
  onOpen: (article: Article) => void;
  title?: string;
}) {
  const [expanded, setExpanded] = useState(false);
  useEffect(() => setExpanded(false), [articles]);
  const visible = expanded ? articles : articles.slice(0, 8);
  if (articles.length === 0) return null;

  return <section className="ranking" aria-labelledby="ranking-title">
    <h2 id="ranking-title"><span /> {title}</h2>
    <div className="ranking__list">
      {visible.map((article, index) => <button type="button" className="ranking-row" key={article.id} onClick={() => onOpen(article)}>
        <span className="ranking-row__number">{String(index + 1).padStart(2, "0")}</span>
        <span className="ranking-row__category">{article.category}</span>
        <time>{article.publishedAt}</time>
        <span className="ranking-row__copy">
          <strong>{article.title}</strong>
          <small>{article.summary}</small>
        </span>
        <span className="ranking-row__sources"><FileText weight="bold" /> {article.sources.length}</span>
        {article.media
          ? <ArticleMedia article={article} compact sizes="190px" caption={false} />
          : <span className="ranking-row__no-media">Tekst</span>}
      </button>)}
    </div>
    {articles.length > 8 && <button className="ranking__more" type="button" onClick={() => setExpanded(value => !value)} aria-expanded={expanded}>
      {expanded ? "Pokaż mniej" : `Zobacz więcej wiadomości (${articles.length - 8})`} <CaretDown className={expanded ? "rotated" : ""} weight="bold" />
    </button>}
  </section>;
}
